export default "__VITE_ASSET__D$knaAM___"